module.exports = __webpack_public_path__ + "img/HU12951659.85b49219.png";